import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1AssessmentsPlansOrganizationList: build.query<
      ApiPortalV1AssessmentsPlansOrganizationListApiResponse,
      ApiPortalV1AssessmentsPlansOrganizationListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/organization/`,
        params: {
          assessment_period_action_plan_id:
            queryArg.assessmentPeriodActionPlanId,
          assessment_period_id: queryArg.assessmentPeriodId,
          leader_id: queryArg.leaderId,
          type_of: queryArg.typeOf,
        },
      }),
    }),
    apiPortalV1AssessmentsPlansOrganizationCreate: build.mutation<
      ApiPortalV1AssessmentsPlansOrganizationCreateApiResponse,
      ApiPortalV1AssessmentsPlansOrganizationCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/organization/`,
        method: "POST",
        body: queryArg.organizationAssessmentPeriodActionPlan,
      }),
    }),
    apiPortalV1AssessmentsPlansOrganizationRetrieve: build.query<
      ApiPortalV1AssessmentsPlansOrganizationRetrieveApiResponse,
      ApiPortalV1AssessmentsPlansOrganizationRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/organization/${queryArg.id}/`,
      }),
    }),
    apiPortalV1AssessmentsPlansOrganizationUpdate: build.mutation<
      ApiPortalV1AssessmentsPlansOrganizationUpdateApiResponse,
      ApiPortalV1AssessmentsPlansOrganizationUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/organization/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.organizationAssessmentPeriodActionPlan,
      }),
    }),
    apiPortalV1AssessmentsPlansOrganizationPartialUpdate: build.mutation<
      ApiPortalV1AssessmentsPlansOrganizationPartialUpdateApiResponse,
      ApiPortalV1AssessmentsPlansOrganizationPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/organization/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedOrganizationAssessmentPeriodActionPlan,
      }),
    }),
    apiPortalV1AssessmentsPlansOrganizationDestroy: build.mutation<
      ApiPortalV1AssessmentsPlansOrganizationDestroyApiResponse,
      ApiPortalV1AssessmentsPlansOrganizationDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/organization/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    apiPortalV1AssessmentsPlansOrganizationLeaderAssignedRetrieve: build.query<
      ApiPortalV1AssessmentsPlansOrganizationLeaderAssignedRetrieveApiResponse,
      ApiPortalV1AssessmentsPlansOrganizationLeaderAssignedRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/organization/leader-assigned/`,
        params: {
          leader_id: queryArg.leaderId,
          type_of: queryArg.typeOf,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1AssessmentsPlansOrganizationListApiResponse =
  /** status 200  */ OrganizationAssessmentPeriodActionPlanRead[];
export type ApiPortalV1AssessmentsPlansOrganizationListApiArg = {
  assessmentPeriodActionPlanId?: number;
  /** Required when type_of is 1 (Organization Goals) or 2 (Team Projects) */
  assessmentPeriodId?: number;
  /** Filter to action plans assigned to the specified leader (Employee id). */
  leaderId?: number;
  /** 1 = Organization Goals, 2 = Team Projects, 3 = Foundations */
  typeOf?: number;
};
export type ApiPortalV1AssessmentsPlansOrganizationCreateApiResponse =
  /** status 201  */ OrganizationAssessmentPeriodActionPlanRead;
export type ApiPortalV1AssessmentsPlansOrganizationCreateApiArg = {
  organizationAssessmentPeriodActionPlan: OrganizationAssessmentPeriodActionPlanWrite;
};
export type ApiPortalV1AssessmentsPlansOrganizationRetrieveApiResponse =
  /** status 200  */ OrganizationAssessmentPeriodActionPlanRead;
export type ApiPortalV1AssessmentsPlansOrganizationRetrieveApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
};
export type ApiPortalV1AssessmentsPlansOrganizationUpdateApiResponse =
  /** status 200  */ OrganizationAssessmentPeriodActionPlanRead;
export type ApiPortalV1AssessmentsPlansOrganizationUpdateApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
  organizationAssessmentPeriodActionPlan: OrganizationAssessmentPeriodActionPlanWrite;
};
export type ApiPortalV1AssessmentsPlansOrganizationPartialUpdateApiResponse =
  /** status 200  */ OrganizationAssessmentPeriodActionPlanRead;
export type ApiPortalV1AssessmentsPlansOrganizationPartialUpdateApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
  patchedOrganizationAssessmentPeriodActionPlan: PatchedOrganizationAssessmentPeriodActionPlanWrite;
};
export type ApiPortalV1AssessmentsPlansOrganizationDestroyApiResponse = unknown;
export type ApiPortalV1AssessmentsPlansOrganizationDestroyApiArg = {
  /** A unique integer value identifying this assessment period action plan. */
  id: number;
};
export type ApiPortalV1AssessmentsPlansOrganizationLeaderAssignedRetrieveApiResponse =
  /** status 200  */ OrganizationAssessmentPeriodActionPlanRead;
export type ApiPortalV1AssessmentsPlansOrganizationLeaderAssignedRetrieveApiArg =
  {
    /** Employee id of the leader to check */
    leaderId: number;
    /** type_of to check (1=Org goals, 2=Team projects, 3=Foundations) */
    typeOf: number;
  };
export type TypeOf3B0Enum = 1 | 2 | 3 | 4;
export type OrganizationAssessmentPeriodActionPlan = {
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  assessment_period_id: number;
  team?: number | null;
  debrief_schedule_id?: number | null;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export type OrganizationAssessmentPeriodActionPlanRead = {
  id: number;
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  template: string;
  assessment_period_id: number;
  team?: number | null;
  debrief_schedule_id?: number | null;
  tasks: string;
  /** Return total number of tasks for this action plan */
  total_task_count: number;
  /** Return number of completed tasks for this action plan */
  completed_task_count: number;
  /** Return percentage of tasks completed */
  percent_complete: number;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export type OrganizationAssessmentPeriodActionPlanWrite = {
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  assessment_period_id: number;
  team?: number | null;
  team_id?: number | null;
  debrief_schedule_id?: number | null;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export type PatchedOrganizationAssessmentPeriodActionPlan = {
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  assessment_period_id?: number;
  team?: number | null;
  debrief_schedule_id?: number | null;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export type PatchedOrganizationAssessmentPeriodActionPlanRead = {
  id?: number;
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  template?: string;
  assessment_period_id?: number;
  team?: number | null;
  debrief_schedule_id?: number | null;
  tasks?: string;
  /** Return total number of tasks for this action plan */
  total_task_count?: number;
  /** Return number of completed tasks for this action plan */
  completed_task_count?: number;
  /** Return percentage of tasks completed */
  percent_complete?: number;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export type PatchedOrganizationAssessmentPeriodActionPlanWrite = {
  organization?: number;
  recommendation?: number | null;
  recommendation_name?: string;
  recommendation_json?: any | null;
  assessment_period_id?: number;
  team?: number | null;
  team_id?: number | null;
  debrief_schedule_id?: number | null;
  leader?: number | null;
  type_of?: TypeOf3B0Enum;
  notes?: string | null;
};
export const {
  useApiPortalV1AssessmentsPlansOrganizationListQuery,
  useApiPortalV1AssessmentsPlansOrganizationCreateMutation,
  useApiPortalV1AssessmentsPlansOrganizationRetrieveQuery,
  useApiPortalV1AssessmentsPlansOrganizationUpdateMutation,
  useApiPortalV1AssessmentsPlansOrganizationPartialUpdateMutation,
  useApiPortalV1AssessmentsPlansOrganizationDestroyMutation,
  useApiPortalV1AssessmentsPlansOrganizationLeaderAssignedRetrieveQuery,
} = injectedRtkApi;
